export const ActionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_SEARCHED_PRODUCTS:"SET_SEARCHED_PRODUCTS",
  REMOVE_SEARCHED_PRODUCTS:"REMOVE_SEARCHED_PRODUCTS",
  SELECTED_PRODUCT: "SELECTED_PRODUCT",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
  ADD_TO_CART:"ADD_TO_CART",
  REMOVE_FROM_CART:"REMOVE_FROM_CART",
  ADD_TO_WISHLIST:"ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST:"REMOVE_FROM_WISHLIST",
  LOGIN_REQUEST:"LOGIN_REQUEST",
  LOGIN_SUCCESS:"LOGIN_SUCCESS",
  LOGIN_FAILURE:"LOGIN_FAILURE",
};
